// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2g5fz","questions":"styles_questions__DbE1h","footer":"styles_footer__31nVv"};